import { useMutation } from '@tanstack/react-query';
import { useApi } from './useApi';

export const useTrackUserEvent = () => {
  const { makeApiRequest } = useApi();

  return useMutation({
    mutationFn: ({
      slug,
      eventCode,
      payload,
    }: {
      slug: string;
      eventCode: string;
      payload: {
        on: string;
        enabled?: boolean;
        agreementId?: string;
      };
    }) => {
      return makeApiRequest(`/events/${slug}:${eventCode}`, 'POST', payload);
    },
  });
};
